import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import { PAGESIZE } from '../../../../utils/constants';
import { FieldErrors } from '../../../../domain/helpers/Errors';
import { validateSchema } from '../../../../common/ValidateSchema';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { EvaluationCriteriaInterface } from '../../../../models/ProcurementModule/EvaluationCriteria';
import { evaluationCriteriaSchema } from '../../../../domain/ValidationSchemas/PurchaseOrder/evaluationCriteria';
import ToastMessage from '../../../../common/ToastMessage';
import CustomDataGrid from '../../../../common/CustomDataGrid';
import useEvaluationCriteria from '../../../../store/ReactQueries/procurements/evaluationCriteria/useEvaluationCriteria';
import useAddEvaluationCriteria from '../../../../store/ReactQueries/procurements/evaluationCriteria/useAddEvaluationCriteria';
import useUpdateEvaluationCriteria from '../../../../store/ReactQueries/procurements/evaluationCriteria/useUpdateEvaluationCriteria';
import useDeleteEvaluationCriteria from '../../../../store/ReactQueries/procurements/evaluationCriteria/useDeleteEvaluationCriteria';

export const EvaluationCriterias = () => {
    const { language } = useLanguageStore();

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [form, setForm] = useState<EvaluationCriteriaInterface>({
        id: '',
        title: '',
    });

    const [modal, setModal] = useState<{ add: boolean, edit: boolean, view: boolean }>({
        add: false,
        edit: false,
        view: false
    });

    let { data: evaluationCriterias, error: evaluationCriteriaError, isLoading } = useEvaluationCriteria(page, pageSize);

    const addEvaluationCriteria = useAddEvaluationCriteria(page, pageSize);
    const updateEvaluationCriteria = useUpdateEvaluationCriteria(page, pageSize);
    const deleteEvaluationCriteria = useDeleteEvaluationCriteria(page, pageSize);

    useEffect(() => {
        if (evaluationCriteriaError) ToastMessage.Failed(`Error: ${evaluationCriteriaError.message}`);
    }, [evaluationCriteriaError])

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false, width: 150 },
        { field: 'title', headerName: 'Title', type: "string", editable: false, width: 400 },
    ];

    const addItems = () => {
        setForm({
            ...form,
            id: '',
            title: ''
        });
        setModal({ ...modal, add: true });
        setErrors({});
    }

    const handleError = (error: unknown) => {
        if (error instanceof Error) ToastMessage.Failed(error.message);
        else ToastMessage.Failed();
    };

    const handleSave = async () => {
        const isValid = validateSchema(evaluationCriteriaSchema, form);

        setErrors(isValid.errors);
        if (!isValid.result) return;

        const { id, title, } = form;

        const upForm: EvaluationCriteriaInterface = {
            id,
            title,
        };

        if (upForm.id === '') {
            const { id, ...formData } = upForm;
            addEvaluationCriteria.mutate(formData, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        } else {
            updateEvaluationCriteria.mutate(upForm, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        }
        setModal({ ...modal, add: false, edit: false, view: false });
    }

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language['ToastDeleteItem'])) {
            deleteEvaluationCriteria.mutate(id, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        }
    };

    return (
        <CustomDataGrid
            name={language['EvaluationCriterias']}
            rows={evaluationCriterias || []}
            form={form}
            page={page}
            modal={modal}
            errors={errors}
            columns={columns}
            loading={isLoading}
            pageSize={pageSize}
            setForm={setForm}
            setPage={setPage}
            addItems={addItems}
            setModal={setModal}
            setErrors={setErrors}
            handleSave={handleSave}
            setPageSize={setPageSize}
            handleDelete={handleDelete}
            hideColumns={['id']}
            showColumnModal={['title']}
        />
    );
}
export default EvaluationCriterias;